import { lazy } from "react";
import type { NavItem } from "../../nav";
import type { SolutionRoute } from "../routes";
import type { SolutionSettings } from "../settings";
import { Icon } from "../../ui";
import "./loops.css";

const LoopsHomePage = lazy(() => import("./home").then((m) => ({ default: m.LoopsHomePage })));
const LoopsLeaderboardPage = lazy(() => import("./leaderboard").then((m) => ({ default: m.LoopsLeaderboardPage })));
const LoopsMemberPage = lazy(() => import("./member").then((m) => ({ default: m.LoopsMemberPage })));
const LoopsMembersPage = lazy(() => import("./members").then((m) => ({ default: m.LoopsMembersPage })));
const LoopsPickupPage = lazy(() => import("./pickup").then((m) => ({ default: m.LoopsPickupPage })));
const LoopsRulesPage = lazy(() => import("./rules").then((m) => ({ default: m.LoopsRulesPage })));
const LoopsShopPage = lazy(() => import("./shop").then((m) => ({ default: m.LoopsShopPage })));
const LoopsInventoryPage = lazy(() => import("./inventory").then((m) => ({ default: m.LoopsInventoryPage })));
const LoopsDesignsPage = lazy(() => import("./designs").then((m) => ({ default: m.LoopsDesignsPage })));
const LoopsRacesPage = lazy(() => import("./races").then((m) => ({ default: m.LoopsRacesPage })));
const LoopsRacePage = lazy(() => import("./races").then((m) => ({ default: m.LoopsRacePage })));
const LoopsRunningPage = lazy(() => import("./running").then((m) => ({ default: m.LoopsRunningPage })));
const LoopsAgentPage = lazy(() => import("./agent").then((m) => ({ default: m.LoopsAgentPage })));
const LoopsHostPage = lazy(() => import("./host").then((m) => ({ default: m.LoopsHostPage })));
const LoopsTapPage = lazy(() => import("./tap").then((m) => ({ default: m.LoopsTapPage })));

/**
 * Loops' admin: its home, members, leaderboard, the rewards stock, the agent, card designs, races, members' running,
 * shop and pick-ups, the rules, and the phone pages (a pick-up, the run host's check-in, a scanned card).
 */
export const routes: SolutionRoute[] = [
  { solution: "loops", path: "loops", element: <LoopsHomePage /> },
  { solution: "loops", path: "loops/members", element: <LoopsMembersPage /> },
  { solution: "loops", path: "loops/members/:id", element: <LoopsMemberPage /> },
  { solution: "loops", path: "loops/leaderboard", element: <LoopsLeaderboardPage /> },
  { solution: "loops", path: "loops/inventory", element: <LoopsInventoryPage /> },
  { solution: "loops", path: "loops/agent", element: <LoopsAgentPage /> },
  { solution: "loops", path: "loops/designs", element: <LoopsDesignsPage /> },
  { solution: "loops", path: "loops/races", element: <LoopsRacesPage /> },
  { solution: "loops", path: "loops/races/:eventId", element: <LoopsRacePage /> },
  { solution: "loops", path: "loops/running", element: <LoopsRunningPage /> },
  { solution: "loops", path: "loops/shop", element: <LoopsShopPage /> },
  { solution: "loops", path: "loops/rules", element: <LoopsRulesPage /> },
  { solution: "loops", path: "loops/pickup", element: <LoopsPickupPage />, bare: true },
  { solution: "loops", path: "loops/pickup/:code", element: <LoopsPickupPage />, bare: true },
  { solution: "loops", path: "loops/host", element: <LoopsHostPage />, bare: true },
  { solution: "loops", path: "loops/tap", element: <LoopsTapPage />, bare: true },
  { solution: "loops", path: "loops/tap/:code", element: <LoopsTapPage />, bare: true },
];

/** The rules are a page of their own (Loops › Rules), so Loops adds no Settings section. */
export const settings: SolutionSettings[] = [];

export const nav: NavItem = {
  to: "/loops",
  label: "Loops",
  icon: Icon.refresh,
  solution: "loops",
  need: "loops.view",
  subs: [
    { to: "/loops/members", label: "Members" },
    { to: "/loops/leaderboard", label: "Leaderboard" },
    { to: "/loops/inventory", label: "Inventory" },
    { to: "/loops/agent", label: "Agent" },
    { to: "/loops/designs", label: "Designs", waiting: { count: "loops.designs", title: "Card designs waiting for a look" } },
    { to: "/loops/races", label: "Races" },
    { to: "/loops/running", label: "Running" },
    { to: "/loops/shop", label: "Shop and pick-ups", also: ["/loops/pickup", "/loops/host", "/loops/tap"] },
    { to: "/loops/rules", label: "Rules" },
  ],
};
